import axios from '@/api/axios'

// `text` and `audio` are mutually exclusive — sending both is a 422, and a blank
// `text` beside a recording reads as both.
const buildDictatedTurn = ({ audio, conversationId, clientId, confirm }) => {
    const form = new FormData()

    form.append('audio', audio, audio.name)

    if (conversationId) form.append('conversation_id', conversationId)
    if (clientId) form.append('client_id', clientId)

    if (confirm) {
        form.append('confirm[type]', confirm.type)
        form.append('confirm[value]', confirm.value)
    }

    return form
}

const buildTypedTurn = ({ text, conversationId, clientId, confirm }) => {
    const body = { text }

    if (conversationId) body['conversation_id'] = conversationId
    if (clientId) body['client_id'] = clientId
    if (confirm) body['confirm'] = confirm

    return body
}

export default {
    sendMessage: (turn) => {
        const isDictated = !!turn.audio

        return axios({
            url: '/base/api/assistant/message',
            method: 'post',
            data: isDictated ? buildDictatedTurn(turn) : buildTypedTurn(turn),
            // Content-Type is left alone: axios drops it for FormData so the
            // browser can add the multipart boundary.
            headers: { Accept: 'application/json' },
        }).then((res) => res.data.data)
    },

    // Only needed to reopen a conversation after a page reload — every line of
    // a live turn arrives in that turn's `replies`.
    getConversation: (id) =>
        axios
            .get(`/base/api/assistant/conversations/${id}`)
            .then((res) => res.data.data),
}
